(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  function setCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function renderDrawer(html) {
    var temp = document.createElement('div');
    temp.innerHTML = html;
    var next = temp.querySelector('#cart-drawer');
    if (next) drawer.innerHTML = next.innerHTML;
  }

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer')
      .then(function (res) { return res.json(); })
      .then(function (data) { renderDrawer(data['cart-drawer']); });
  }

  function closeMobileMenu() {
    var menu = document.querySelector('.revor-header__hamburger[open]');
    if (menu) menu.removeAttribute('open');
  }

  // A CSS `overflow: hidden` class on <body> alone doesn't reliably stop
  // touch scrolling on iOS Safari — pinning the body in place with a
  // negative top offset (and restoring the scroll position on close) is
  // the standard cross-browser fix, so background content can't be
  // scrolled behind the drawer on phones.
  var lockedScrollY = 0;

  function openDrawer() {
    closeMobileMenu();
    if (!drawer.classList.contains('cart-drawer--open')) {
      lockedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + lockedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
    }
    drawer.classList.add('cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    drawer.classList.remove('cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, lockedScrollY);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
      return;
    }
    var opener = event.target.closest('[data-cart-drawer-toggle]');
    if (opener) {
      event.preventDefault();
      refreshDrawer().then(openDrawer);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (form.matches('form[action*="/cart/add"]')) {
      // Let "Buy Now" submit natively so it still redirects straight to
      // checkout instead of opening the drawer.
      if (event.submitter && event.submitter.name === 'return_to') return;

      event.preventDefault();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js').then(function (res) { return res.json(); }); })
        .then(function (cart) {
          setCounts(cart.item_count);
          return refreshDrawer();
        })
        .then(openDrawer);
      return;
    }

    if (form.hasAttribute('data-cart-drawer-form')) {
      event.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          setCounts(cart.item_count);
          return refreshDrawer();
        });
      return;
    }

    if (form.hasAttribute('data-cart-drawer-discount-form')) {
      // Shopify carts don't support applying discount codes via the AJAX
      // Cart API — the code is applied by carrying it through to checkout.
      event.preventDefault();
      var code = form.elements.discount.value.trim();
      if (code) window.location.href = '/checkout?discount=' + encodeURIComponent(code);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var header = document.querySelector('.revor-header--transparent');
  if (!header) return;

  var scrollThreshold = 40;

  function updateScrolledState() {
    header.classList.toggle('is-scrolled', window.scrollY > scrollThreshold);
  }

  updateScrolledState();
  window.addEventListener('scroll', updateScrolledState, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('.promotion-bar');
  if (!bar) return;

  // header.liquid, revor-hero.liquid and product.liquid all position
  // themselves relative to `--promotion-bar-height` so they line up flush
  // against this bar with no gap. A hardcoded guess drifts out of sync with
  // the bar's real height whenever the theme's base font size (or a
  // browser's own text rendering) makes the bar taller or shorter than
  // assumed — measuring it directly keeps every dependent element exactly
  // in sync no matter what.
  function updateHeight() {
    document.documentElement.style.setProperty('--promotion-bar-height', bar.offsetHeight + 'px');
  }

  updateHeight();
  window.addEventListener('resize', updateHeight);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateHeight);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
